import type { ColorTint } from '@/types/components/common'

export const FONT_FAMILY = "'Epilogue', sans-serif"

export const LABEL_FONT_SIZE = 12

export const TINT_COLORS: ColorTint[] = [
  'blue',
  'grey',
  'aqua',
  'palablue',
  'purple',
  'pink',
  'rose',
  'red',
  'brown',
  'orange',
  'yellow',
  'grass',
  'green',
  'pea',
]

export const BG_ALPHA_TINT_COLOR_MAP: { [key in ColorTint]: string } = {
  blue: 'bg-blue-alpha',
  grey: 'bg-grey-alpha',
  aqua: 'bg-aqua-alpha',
  palablue: 'bg-palablue-alpha',
  purple: 'bg-purple-alpha',
  pink: 'bg-pink-alpha',
  rose: 'bg-rose-alpha',
  red: 'bg-red-alpha',
  brown: 'bg-brown-alpha',
  orange: 'bg-orange-alpha',
  yellow: 'bg-yellow-alpha',
  grass: 'bg-grass-alpha',
  green: 'bg-green-alpha',
  pea: 'bg-pea-alpha',
}

export const BG_TINT_COLOR_MAP: { [key in ColorTint]: string } = {
  blue: 'bg-blue-53',
  grey: 'bg-grey-53',
  aqua: 'bg-aqua-53',
  palablue: 'bg-palablue-53',
  purple: 'bg-purple-53',
  pink: 'bg-pink-53',
  rose: 'bg-rose-53',
  red: 'bg-red-53',
  brown: 'bg-brown-53',
  orange: 'bg-orange-53',
  yellow: 'bg-yellow-53',
  grass: 'bg-grass-53',
  green: 'bg-green-53',
  pea: 'bg-pea-53',
}

export const HOVER_BG_TINT_COLOR_MAP: { [key in ColorTint]: string } = {
  blue: 'hover:bg-blue-43',
  grey: 'hover:bg-grey-43',
  aqua: 'hover:bg-aqua-43',
  palablue: 'hover:bg-palablue-43',
  purple: 'hover:bg-purple-43',
  pink: 'hover:bg-pink-43',
  rose: 'hover:bg-rose-43',
  red: 'hover:bg-red-43',
  brown: 'hover:bg-brown-43',
  orange: 'hover:bg-orange-43',
  yellow: 'hover:bg-yellow-43',
  grass: 'hover:bg-grass-43',
  green: 'hover:bg-green-43',
  pea: 'hover:bg-pea-43',
}

export const BORDER_TINT_COLOR_MAP: { [key in ColorTint]: string } = {
  blue: 'border-blue-53',
  grey: 'border-grey-53',
  aqua: 'border-aqua-53',
  palablue: 'border-palablue-53',
  purple: 'border-purple-53',
  pink: 'border-pink-53',
  rose: 'border-rose-53',
  red: 'border-red-53',
  brown: 'border-brown-53',
  orange: 'border-orange-53',
  yellow: 'border-yellow-53',
  grass: 'border-grass-53',
  green: 'border-green-53',
  pea: 'border-pea-53',
}
